import "./text-alert.css";

import { LiveLikeAlert } from "@livelike/engagementsdk";

const html = (window as any).html;

class SBSTextAlert extends LiveLikeAlert {
  render() {
    const text = this.widgetPayload?.text ?? "";
    const linkUrl = this.widgetPayload?.link_url ?? "";

    const body = text;
    if (!body.length) {
      return null;
    }

    return html`
      <template kind="alert">
        <livelike-widget-root class="sbs-custom-alert-widget-root">
          <livelike-widget-body>
            <div class="custom-alert-container">
              <div class="custom-alert-text">${body}</div>
              ${linkUrl
                ? html`<a
                    class="custom-alert-cta"
                    href="${linkUrl}"
                    target="_blank"
                    rel="noreferrer"
                    >Read more</a
                  >`
                : ""}
            </div>
          </livelike-widget-body>
        </livelike-widget-root>
      </template>
    `;
  }
}

customElements.define("sbs-text-alert", SBSTextAlert as any);
